import { create } from 'zustand';

import type { TAdvertiserStore } from './advertiser.types';
import { ADVERTISER_INITIAL_STATE } from './advertiser.initial-state';

export const useAdvertiserStore = create<TAdvertiserStore>()((set) => ({
  ...ADVERTISER_INITIAL_STATE,

  fetchLoading: () => set({ loading: true, error: null }),

  fetchFulfilled: (source) => set({ fetched: true, loading: false, source, error: null }),

  fetchRejected: (error) => set({ fetched: false, loading: false, error }),

  resetAdvertiser: () => set({ ...ADVERTISER_INITIAL_STATE }),
}));
